import React from 'react';
import { useTranslation } from 'react-i18next';

import { CircularIndicator } from '@make-software/cspr-ui';
import { BodyText } from '@block-explorer/ui';

interface TableDataValidatorInfoProps {
  performanceScore?: number;
  textSize: 1 | 2;
}

export const TableDataValidatorPerformance = ({
  performanceScore,
  textSize,
}: TableDataValidatorInfoProps) => {
  const { t } = useTranslation();

  return (
    <>
      {performanceScore == null || performanceScore == 0 ? (
        <BodyText size={3} variation="darkGray">
          {t('No data')}
        </BodyText>
      ) : (
        <CircularIndicator
          size="medium"
          progress={performanceScore}
          textSize={textSize}
          title={t("Validator's performance ") + performanceScore}
        />
      )}
    </>
  );
};
